import React, { Component } from 'react';
import { connect } from 'react-redux';
import Orders from './orders';
import {take} from 'ramda';
import {lowestDenom} from '../../../../config';
import {Decimal} from 'decimal.js'
import InfiniteScroll from 'react-infinite-scroll-component';

class Buy extends Component {
  constructor(){
    super()
    this.state = {hasMore:false,nextIndex:1,orders:[]}
  }
  componentDidUpdate(prevProps){
    if(prevProps.marketText != this.props.marketText){
      this.setState({orders:take(40,this.props.orders),hasMore:true,nextIndex:1})
    }
    else if(prevProps.orders.length === 0 && this.props.orders.length > 0){
      this.setState({orders:take(40,this.props.orders),hasMore:true,nextIndex:1})
    }
    else if(this.props.orders.length != prevProps.orders.length){
      this.setState({hasMore:true,orders:take(this.state.nextIndex*40,this.props.orders)})
    }
    else if(this.props.ordersHash != prevProps.ordersHash){
      this.setState({hasMore:true,orders:take(40,this.props.orders),nextIndex:1})
    }
  }
  componentDidMount(){
    this.setState({orders:take(40,this.props.orders),hasMore:true})
  }
  fetchMoreData(){
    let { nextIndex, orders} = this.state;
    nextIndex++;
    this.setState({orders:take(40*nextIndex,this.props.orders),nextIndex})
    if(40*nextIndex >= this.props.orders.length){
      this.setState({hasMore:false,nextIndex})
    }
    console.log({nextIndex,hasMore:this.state.hasMore})
    return;
  }
  render() {
    let style = {}
    let height = 340;

    if(this.props.market.sellSide == false){
      height = 705;
      style = {
        height:`${height}px`,
        maxHeight:'705px'
      }
    }

    return (
      <div className="col s12 mainbook" id={'offertable'} style={style}>
      <InfiniteScroll
            height={height}
            dataLength={this.state.orders.length}
            next={this.fetchMoreData.bind(this)}
            hasMore={this.state.hasMore}
        >
        <Orders orderType={"buy"} orders={this.state.orders}/>
        </InfiniteScroll>
      </div>
    );
  }
}

function mapStateToProps(state,props) {
  let orders =  state.orderbook.sub_demand;
  let market = state.ui_marketplace.market;

  return {
    marketText: `${state.ui_marketplace.market.denomination}${state.ui_marketplace.market.asset}`,
    market: state.ui_marketplace.market,
    ordersHash: state.orderbook.sub_demand_hash,
    orders
  };
}

export default connect(mapStateToProps,{})(Buy);
